import React, {PureComponent} from "react";
import GoogleLoginButton from "./buttons/social/GoogleLoginButton";
import {connect} from "react-redux";

class SocialLogin extends PureComponent {

    render() {
        const {socialAuthStatus} = this.props.site;

        if (!socialAuthStatus) {
            return null;
        }

        return <div className="row">
            <div className="column">
                <GoogleLoginButton />
            </div>
        </div>
    }
}

export default connect(
    state => ({
        site: state.site,
    })
)(SocialLogin);